module.exports = lozad;